import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import PageHero from '../../components/PageHero/PageHero'

const Services = () => {
  return (
    <>
      <Helmet>
        <title>Our Services - Proof of Reserves Auditor</title>
        <meta name="description" content="Comprehensive proof of reserves solutions including conventional, Merkle tree, on-chain, and real-time verification." />
      </Helmet>

      <div className="services-page">
        <PageHero
          title="Our Services"
          description="Comprehensive proof of reserves solutions tailored to your needs"
        />

        <section className="section-padding bg-white">
          <div className="container-custom">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[
                { title: 'Conventional Proof of Reserves', link: '/services/conventional-proof-of-reserves' },
                { title: 'Merkle Tree Verification', link: '/services/merkle-tree-proof-of-reserves' },
                { title: 'On-Chain Verification', link: '/services/on-chain-proof-of-reserves' },
                { title: 'Real-Time Monitoring', link: '/services/real-time-proof-of-reserves' },
              ].map((service, i) => (
                <Link
                  key={i}
                  to={service.link}
                  className="p-8 border border-gray-200 rounded-lg hover:shadow-lg transition-all hover:-translate-y-1"
                >
                  <h3 className="text-2xl font-bold text-primary mb-4">{service.title}</h3>
                  <p className="text-gray-600 mb-4">
                    Learn more about our {service.title.toLowerCase()} service
                  </p>
                  <span className="text-accent font-semibold">Learn More →</span>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default Services